module.exports = __webpack_public_path__ + "static/media/client-6.ed38c36f.png";